import { render } from "./EditExerciseSheetQuestionTheme.vue?vue&type=template&id=0fcbe6ad"
import script from "./EditExerciseSheetQuestionTheme.vue?vue&type=script&lang=js"
export * from "./EditExerciseSheetQuestionTheme.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__